/**
 * Created by akirilyuk on 11/28/16.
 */
/**********************************************************************************************************
 *  V1.0
 *
 *  User: akirilyuk
 *  Date: 24/11/2016
 *
 *  Options:
 *  el              -   mandatory. container where this widget will be appended to
 *  initialDate     -   optional. date which will be shown at the beginning, if not set the current DateTime will be shown
 *  maxDate         -   optional. limits the maximum selectable date
 *  minDate         -   optional. limits the minimum selectable date
 *  limitToNow      -   optional. limits the max date to the current date, as it return a new date object every time the getMaxDate
 *                      function is called. Overrides the maxDate;
 *
 *  --Example usage--:
 *
 *  var minDate = new Date();
 *  minDate.setFullYear(minDate.getFullYear()-1);
 *  var maxDate = new Date();
 *  maxDate.setFullYear(maxDate.getFullYear()+1);
 *
 *  var dateTimePickerWidget = new DateTimePicker({
 *                              el: this.ui.dateTimePickerContainer,
 *                              initialDate: new Date(),
 *                              minDate: minDate,
 *                              maxDate: maxDate
 *  });
 *
 *  dateTimePickerWidget.render();
 *
 *  This sets the maxDate a year after now, and the minDate a year before now.
 *
 *  --Events--:
 *
 *  DateTimePicker.TRIGGERING.DONE_CLICKED - Event that gets triggered if user has clicked the "Done" button.
 *  DateTimePicker.TRIGGERING.DATE_CHANGED - Event that gets triggered if only date is changed by date it means year, month, day.
 *  DateTimePicker.TRIGGERING.HOURS_CHANGED - Event that gets triggered if hours have changed.
 *  DateTimePicker.TRIGGERING.MINUTES_CHANGED - Event that gets triggered if minutes have changed.
 *  DateTimePicker.TRIGGERING.TIME_CHANGED - Event that gets triggered if either hours or minutes has changed.
 *  DateTimePicker.TRIGGERING.DATE_TIME_CHANGED - Event that gets triggered if date OR time has changed, basically it gets trigger if anything ahs changed.
 *  DateTimePicker.TRIGGERING.NOW_CLICKED - Event that fires when the now button was clicked
 *
 * *******************************************************************************************************
 */
define(function (require) {
    "use strict";

    var Button = require("ui/button/Button");
    var DatePicker = require("ui/datepicker/DatePicker");
    var InputField = require("ui/input-field/InputField");
    var template = require("connection-templates/ticketTab/widgets/dateTimePicker.tmpl");
    var DateTimePicker = {};
    var LE = require("app");

    var TRIGGERING = {
        DONE_CLICKED: "doneClicked",
        DATE_CHANGED: "dateChanged",
        HOURS_CHANGED: "hoursChanged",
        MINUTES_CHANGED: "minutesChanged",
        TIME_CHANGED: "timeChanged",
        DATE_TIME_CHANGED: "dateTimeChanged",
        NOW_CLICKED: "nowClicked"
    };

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        DateTimePicker = Marionette.ItemView.extend({
            template: template,
            className: "ui-date-time-picker",
            ui: {
                datePickerContainer: ".date-picker-container",
                timePickerContainer: ".time-picker-container",
                timeLabel: ".time-label",
                hoursLabel: ".hours-label",
                minutesLabel: ".minutes-label",
                timeValue: ".time-value",
                hoursSlider: ".hours-slider",
                minutesSlider: ".minutes-slider",
                nowButtonContainer: ".now-button-container",
                doneButtonContainer: ".done-button-container"
            },
            uiComponents: {
                datePicker: {
                    type: DatePicker,
                    options: {
                        el: "view.ui.datePickerContainer",
                        permutation: DatePicker.DateFormat.Full
                    }
                },
                nowButton: {
                    type: Button,
                    options: {
                        el: "view.ui.nowButtonContainer",
                        permutation: Button.PERMUTATION.BTN_SHORT,
                        text: LE.translator.translate("LEConnection.cases.datetimepicker.button.now")
                    },
                    events: {
                        "click": "_onNowClick"
                    }
                },
                doneButton: {
                    type: Button,
                    options: {
                        el: "view.ui.doneButtonContainer",
                        permutation: Button.PERMUTATION.BTN_SHORT,
                        text: LE.translator.translate("LEFramework.global.captions.done")
                    },
                    events: {
                        "click": "_onDoneClick"
                    }
                },
                timeInputField: {
                    type: InputField,
                    options: {
                        el: "view.ui.timeValue",
                        permutation: InputField.Permutation.D,
                        maxLength: 5
                    }
                }
            },
            //WIDGET INITIALIZATION
            initialize: function (options) {
                if (!_.isNull(options)) {
                    if (!_.isNull(options.el)) {
                        this.container = options.el;
                    } else {
                        throw new Error("NO container element defined, can not initialize DateTimePicker!");
                    }
                    this._setMaxDateLimited(options.limitToNow);
                    this._setMaxDate(options.maxDate);
                    this._setMinDate(options.minDate);
                    this._setCurrentDate(options.initialDate);
                } else {
                    throw new Error("Missing options, can not initialize DateTimePicker!");
                }
                this.hourValue = 0;
                this.minutesValue = 0;
                this.timeValue = "00:00";
            },

            onRender: function () {
                this.container.append(this);
                this._generateSlides();
                this._bindEvents();
                this._initText();
                this._setDatePickerMinDate(this.getMinDate());
                this._setDatePickerMaxDate(this.getMaxDate());
                this._setDatePicker(this._getCurrentDate());
                this._updateViewFromDateObject(this._getCurrentDate());
            },
            //PUBLIC METHODS
            /**
             * return the current selected date
             *
             * @returns {Date}
             */
            getDate: function () {
                return this._getCurrentDate();
            },

            /**
             * sets the current date and updates the ui
             * @param date Date object
             */
            setDate: function (date) {
                this._setCurrentDate(date);
                this._updateViewFromDateObject(date);
            },

            /**
             * get the current set maxDate
             * @returns {Date}
             */
            getMaxDate: function () {
                return this._getMaxDate();
            },

            /**
             * set the maxDate limitation
             * @param date Date object
             */
            setMaxDate: function (date) {
                this._setMaxDate(date);
            },

            /**
             * get the current set minDate limitation
             *
             * @returns {Date}
             */
            getMinDate: function () {
                this._getMinDate();
            },

            /**
             * set the minDate limitation
             * @param date Date object
             */
            setMinDate: function (date) {
                this._setMinDate(date);
            },

            //PRIVATE METHODS
            _bindEvents: function () {
                this.listenTo(this.uiComponents.datePicker, DatePicker.TRIGGERING.DATE_SELECTED, this._onDateSelected);
                this.listenTo(this.uiComponents.timeInputField,InputField.TRIGGERING.CHANGE,this._onTimeInputChanged);

            },

            _initText: function () {
                $(this.ui.timeLabel).html(LE.translator.translate("LEConnection.cases.datetimepicker.label.time"));
                $(this.ui.hoursLabel).html(LE.translator.translate("LEConnection.cases.datetimepicker.label.hours"));
                $(this.ui.minutesLabel).html(LE.translator.translate("LEConnection.cases.datetimepicker.label.minutes"));
            },

            //Init the 2 time slides and bind event handlers
            _generateSlides: function () {
                $(this.ui.hoursSlider).slider({
                    min: 0,
                    max: 23,
                    step: 1,
                    change: _.bind(this._onHoursSliderChange, this),
                    slide: _.bind(this._onHourSliderSlide, this)
                });
                $(this.ui.minutesSlider).slider({
                    min: 0,
                    max: 59,
                    step: 1,
                    change: _.bind(this._onMinutesSliderChange, this),
                    slide: _.bind(this._onMinuteSliderSlide, this)
                });
            },

            //SETTER AND GETTER
            _setFromDateObject: function (date) {
                this._setCurrentDate(date);
                this._updateViewFromDateObject(date);
            },

            _setHours: function (value) {
                this._getCurrentDate().setHours(value);
                this._setHourSlider(value);
                this.trigger(TRIGGERING.HOURS_CHANGED);
                this.trigger(TRIGGERING.TIME_CHANGED);
                this.trigger(TRIGGERING.DATE_TIME_CHANGED);
            },

            _setMinutes: function (value) {
                this._getCurrentDate().setMinutes(value);
                this._setMinutesSlider(value);
                this.trigger(TRIGGERING.MINUTES_CHANGED);
                this.trigger(TRIGGERING.TIME_CHANGED);
                this.trigger(TRIGGERING.DATE_TIME_CHANGED);
            },

            // we need to make a difference between full date with time and date only
            _setDate: function (date) {
                if (!_.isNull(date) && _.isDate(date)) {
                    this.date.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
                    this._validateAndSetHours(this._getHours(),true);
                    this.trigger(TRIGGERING.DATE_CHANGED);
                    this.trigger(TRIGGERING.DATE_TIME_CHANGED);
                }
            },
            _setCurrentDate: function (date) {
                this.date = (!_.isNull(date) && _.isDate(date)) ? date : new Date();
                this.trigger(TRIGGERING.DATE_TIME_CHANGED);
            },

            _setMaxDate: function (date) {
                this.maxDate = (!_.isNull(date) && _.isDate(date)) ? date : null;
            },

            _setMinDate: function (date) {
                this.minDate = (!_.isNull(date) && _.isDate(date)) ? date : null;
            },

            _setDatePicker: function (date) {
                this.uiComponents.datePicker.setSelectedDate(date);
            },

            _setDatePickerMinDate: function (date) {
                this.uiComponents.datePicker.setMinDate(date);
            },

            _setDatePickerMaxDate: function (date) {
                this.uiComponents.datePicker.setMaxDate(date);
            },

            _getHours: function () {
                return this._getCurrentDate().getHours();
            },

            _getMinutes: function () {
                return this._getCurrentDate().getMinutes();
            },

            _getCurrentDate: function () {
                return this.date;
            },

            _getMaxDate: function () {
                if(this._maxDateIsLimitedToNow()){
                    var date = new Date();
                    date.setSeconds(0);
                    return date;
                }else{
                    return this.maxDate;
                }
            },

            _getMinDate: function () {
                return this.minDate;
            },

            _setMaxDateLimited: function(value){
                if(!_.isNull(value)&&_.isBoolean(value)){
                    this.maxDateLimited = value;
                }else{
                    this.maxDateLimited = false;
                }
            },

            _maxDateIsLimitedToNow: function(){
                return this.maxDateLimited===true;
            },

            //EVENT HANDLING
            _onTimeInputChanged: function(){
                var value = this.uiComponents.timeInputField.getValue();
                if(value.length>3){
                    var hours;
                    var minutes;
                    if(value.match(/\b[0-9]:[0-5][0-9]$/g)) {//ex 9:45
                        hours = parseInt(value.charAt(0), 10);
                        minutes = parseInt(value.slice(2, 4), 10);
                    }
                    else if(value.match(/\b(([0-1][0-9])|(2[0-4]))[0-5][0-9]$/g)){//ex 1000
                        hours = parseInt(value.slice(0,2),10);
                        minutes = parseInt(value.slice(2,5),10);
                    }
                    else if(value.match(/\b(([0-1][0-9])|(2[0-4])):[0-5][0-9]$/g)){//ex 10:00
                        hours = parseInt(value.slice(0,2),10);
                        minutes = parseInt(value.slice(3,5),10);
                    }else{
                        this.uiComponents.timeInputField.setError(true,"");
                    }
                    if(!_.isUndefined(hours)&&!_.isUndefined(minutes)){
                        this._validateAndSetHoursAndMinutes(hours,minutes);
                    }
                }
            },

            _onMinuteSliderSlide: function (event, ui) {
                this._setMinutesValue(ui.value);
            },

            _onHourSliderSlide: function (event, ui) {
                this._setHoursValue(ui.value);
            },

            _onMinutesSliderChange: function (event, ui) {
                this._validateAndSetMinutes(ui.value);
            },

            _onHoursSliderChange: function (event, ui) {
                this._validateAndSetHours(ui.value);
            },

            _onDateSelected: function () {
                var selectedDate = this.uiComponents.datePicker.getSelectedDate();
                this._setDate(selectedDate);
            },

            _onNowClick: function () {
                this._setViewToCurrentDateTime();
                this.trigger(TRIGGERING.NOW_CLICKED);
            },

            _onDoneClick: function () {
                this.trigger(TRIGGERING.DONE_CLICKED);
            },

            //LOGIC
            _validateAndSetHoursAndMinutes: function(hours,minutes){
                this._validateAndSetHours(hours);
                if(this._getHours()===hours){
                    this._validateAndSetMinutes(minutes);
                }
            },

            _validateAndSetHours: function (value,override) {
                if (value != this._getHours()||override) {
                    var maxDate = this._getMaxDate();
                    var minDate = this._getMinDate();
                    if(maxDate||minDate){
                        if(this._isSameDay(maxDate,this._getCurrentDate())){
                            if(maxDate.getHours()<value){
                                this._updateAllHoursFields(maxDate.getHours());
                                this._validateAndSetMinutes(this._getMinutes());
                            }else{
                                this._setHours(value);
                            }
                        }
                        else if(this._isSameDay(minDate,this._getCurrentDate())){
                            if (minDate && minDate.getHours() > value) {
                                this._updateAllHoursFields(minDate.getHours());
                                this._validateAndSetMinutes(this._getMinutes());
                            }else{
                                this._setHours(value);
                            }
                        }else{
                            this._setHours(value);
                        }
                    }else{
                        this._setHours(value);
                    }
                    this._validateAndSetMinutes(this._getMinutes());
                }
            },

            _validateAndSetMinutes: function (value) {
                var maxDate = this._getMaxDate();
                var minDate = this._getMinDate();
                if(maxDate||minDate){
                    if(this._isSameDay(maxDate,this._getCurrentDate())){
                        if (maxDate.getHours() == this._getHours() && maxDate.getMinutes() < value) {
                            this._updateAllMinutesFields(maxDate.getMinutes());
                        }else{
                            this._setMinutes(value);
                        }
                    }
                    else if(this._isSameDay(minDate,this._getCurrentDate())){
                        if(minDate.getHours()===this._getHours() && minDate.getMinutes() > value){
                            this._updateAllMinutesFields(minDate.getMinutes());
                        }else{
                            this._setMinutes(value);
                        }
                    }else{
                        this._setMinutes(value);
                    }

                }else {
                    this._setMinutes(value);
                }
            },

            _isSameDay: function(date1,date2){
                if(date1&&date2){
                    return (date1.getFullYear()===date2.getFullYear()&&date1.getMonth()===date2.getMonth()&&date1.getDate()===date2.getDate());
                }
                return false;
            },

            //VIEW MODIFICATION
            _updateAllHoursFields: function (hours) {
                this._setHours(hours);
                this._setHoursValue(hours);
            },

            _updateAllMinutesFields: function (minutes) {
                this._setMinutes(minutes);
                this._setMinutesValue(minutes);
            },

            _updateViewFromDateObject: function (date) {
                //assigne local variables because we have more than one function call -> faster
                this._updateAllHoursFields(date.getHours());
                this._updateAllMinutesFields(date.getMinutes());
                this._setDatePicker(date);
            },

            _setHoursValue: function (value) {
                var hourValue = (value < 10) ? "0" + value.toString() : value;
                this.hourValue = (hourValue);
                this._setTimeInputValue(this.hourValue);
            },

            _setMinutesValue: function (value) {
                var minutesValue = (value < 10) ? "0" + value.toString() : value;
                this.minutesValue = (minutesValue);
                this._setTimeInputValue(null,this.minutesValue);
            },

            _setHourSlider: function (value) {
                if(this._getHoursSliderValue()!=value){
                    $(this.ui.hoursSlider).slider("value", value);
                }
            },

            _setMinutesSlider: function (value) {
                if(this._getMinutesSliderValue()!=value){
                    $(this.ui.minutesSlider).slider("value", value);
                }
            },
            _getHoursSliderValue: function(){
                return $(this.ui.hoursSlider).slider("value");
            },

            _getMinutesSliderValue:function(){
                return $(this.ui.minutesSlider).slider("value");
            },

            _setViewToCurrentDateTime: function () {
                var currentDate = new Date();
                currentDate.setSeconds(0);
                this._setFromDateObject(currentDate);
            },

            _setTimeInputValue: function(hours,minutes){
                if(hours){
                    this.timeValue = hours + ":" + this.timeValue.slice(3,5);
                }
                if(minutes){
                    this.timeValue = this.timeValue.slice(0,2) + ":" + minutes;
                }
                this.uiComponents.timeInputField.setValue(this.timeValue);
            }

        });
    });

    DateTimePicker.TRIGGERING = TRIGGERING;

    return DateTimePicker;
});
